<template>
  <div>
    <div class="title">
      <Breadcrumb>
        <BreadcrumbItem
          to="/permissionsConfigurationManagement/roleManagement"
          >{{
            $t("permission_configuration_management.role.roleManagement")
          }}</BreadcrumbItem
        >
        <BreadcrumbItem>{{
          this.$route.query.id
            ? this.$t("permission_configuration_management.common.edit")
            : this.$t("permission_configuration_management.role.addRole")
        }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Form
      ref="roleManagementForm"
      :model="roleManagementForm"
      :label-width="100"
      :rules="ruleValidate"
    >
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p
              slot="title"
              style="line-height:16px;font-size:13px;color:#000;height: 15px;"
            >
              {{ $t("resourceLifecycle.basicInformation") }}
            </p>
            <Row :gutter="16">
              <Col span="12" v-if="this.$route.query.id">
                <FormItem
                  :label="
                    $t('permission_configuration_management.account.company')
                  "
                  >{{ this.$route.query.companyName }}</FormItem
                >
              </Col>
              <Col span="12" v-else>
                <!-- 公司 -->
                <div v-if="company == 1">
                  <FormItem
                    :label="
                      $t('permission_configuration_management.account.company')
                    "
                    prop="companyId"
                  >
                    <Select
                      v-model="companyId"
                      placeholder=""
                      @on-change="searchCompany"
                    >
                      <Option
                        :value="item.id"
                        v-for="(item, index) in companyList"
                        v-bind:key="index"
                        >{{ item.name }}
                      </Option>
                    </Select>
                  </FormItem>
                </div>
              </Col>
            </Row>
            <Row :gutter="16" v-if="this.$route.query.id">
              <Col span="12">
                <FormItem
                  :label="
                    $t('permission_configuration_management.role.roleName')
                  "
                  >{{ roleManagementForm.roleName }}</FormItem
                >
              </Col>
            </Row>
            <Row :gutter="16" v-else>
              <Col span="12">
                <!-- 角色名称 -->
                <FormItem
                  :label="
                    $t('permission_configuration_management.role.roleName')
                  "
                  prop="roleName"
                >
                  <Input
                    v-model="roleManagementForm.roleName"
                    placeholder=""
                  ></Input>
                </FormItem>
              </Col>
            </Row>
            <Row :gutter="16">
              <Col span="12">
                <!-- 状态 -->
                <FormItem :label="$t('satisfaction.status')" prop="status">
                  <Select v-model="roleManagementForm.status" placeholder="">
                    <Option
                      :value="item.status"
                      v-for="(item, index) in statusList"
                      v-bind:key="index"
                      >{{ item.statusName }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Row>

            <!-- 菜单权限 -->
            <FormItem
              :label="$t('permission_configuration_management.role.menuData')"
            >
              <Tree
                :data="menuData"
                @on-check-change="selectAll"
                show-checkbox
                multiple
                ref="tree"
                :render="renderContent"
              ></Tree>
            </FormItem>

            <!-- 备注 -->
            <FormItem
              :label="$t('permission_configuration_management.role.remark')"
              prop="remark"
            >
              <Input
                v-model="roleManagementForm.remark"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                placeholder=""
              ></Input>
            </FormItem>
          </Card>
        </Col>
      </Row>
    </Form>
    <div slot="footer" style="float: right;">
      <Button @click="backtrack">{{ $t("alarms.common.back") }}</Button>
      <Button
        type="primary"
        @click="submit('roleManagementForm')"
        :loading="loading"
        >{{ $t("common.submit") }}</Button
      >
    </div>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
var roleManagementVue = {};
export default {
  inject: ["reload"],
  data() {
    // 名字是否重复
    var validNameRepeatedCheck = (rule, value, callback) => {
      var self = this;
      self.$api.security
        .roleNameCheck("roleName", this.roleManagementForm.roleName)
        .then(res => {
          if (res.status == 200) {
            callback();
          }
        })
        .catch(err => {
          if (err.status == 400) {
            callback(new Error(this.$t("permission_configuration_management.role.roleNameDuplicate")));
          }
        });
    };
    return {
      companyName: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      loading: false,
      modal: false,
      selection: [],
      roleManagementForm: {
        roleName: "",
        status: "",
        remark: ""
      },
      statusList: [
        {
          status: 1,
          statusName: this.$t(
            "permission_configuration_management.account.enable"
          )
        },
        {
          status: 0,
          statusName: this.$t(
            "permission_configuration_management.account.disable"
          )
        }
      ],
      ruleValidate: {
        roleName: [
          { required: true, message: this.$t("permission_configuration_management.role.roleNameRequired"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("permission_configuration_management.role.roleNameLength"),
            pattern: "^.{2,20}$",
            trigger: "blur"
          },
          { validator: validNameRepeatedCheck, trigger: "blur" }
        ],
        status: [
          {
            required: true,
            message: this.$t("permission_configuration_management.role.pleaseSelectStatus"),
            trigger: "change",
            type: "number"
          }
        ],
        remark: [
          { required: false, message: this.$t("permission_configuration_management.role.pleaseInputRemark"), trigger: "blur" },
          {
            type: "string",
            max: 100,
            message: this.$t("permission_configuration_management.role.maxChars100"),
            trigger: "blur"
          }
        ]
      },
      menuData: [],
      menuIdData: [],
      subdata: [],
      getEditCompanyId: ""
    };
  },

  beforeCreate: function() {
    roleManagementVue = this;
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
    // 编辑
    if (this.$route.query.id) {
      this.select();
    } else {
      this.companyId = this.company
      this.$api.security
        .menuTreeNode({
          userName: getCookie(global.cookieName),
          companyId: this.companyId
        })
        .then(res => {
          // 所有菜单数组
          this.menuData = res.data;
        });
    }
  },
  methods: {
    searchCompany() {
      this.$api.security
        .menuTreeNodeEdit({
          roleId: this.$route.query.id == undefined ? "" : this.$route.query.id,
          companyId: this.companyId
        })
        .then(res => {
          // 所有菜单数组
          this.menuData = res.data;
        });
    },
    /*********************************  编辑  ************************************/
    select: function() {
      this.$api.security.select("roleId", this.$route.query.id).then(res => {
        this.getEditCompanyId = res.data.companyId;
        // 角色名称
        this.roleManagementForm.roleName = res.data.roleName;
        // 状态
        this.roleManagementForm.status = res.data.statusInt;
        // 查询接口返回的菜单权限
        this.menuIdData = res.data.menuList;
        // 备注
        this.roleManagementForm.remark = res.data.remark;
        this.search();
      });
    },
    /**************************************  查询  **************************************/
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 显示不同图标
    renderContent(h, { root, node, data }) {
      if (data.menuType == "B") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-radio-button-on"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      } else if (data.menuType == "C") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-bookmark"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      } else if (data.menuType == "M") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-grid"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      }
    },
    // 查询菜单模块
    search: function() {
      this.$api.security
        .menuTreeNodeEdit({
          roleId: this.$route.query.id,
          companyId: this.getEditCompanyId
        })
        .then(res => {
          // 所有菜单数组
          this.menuData = res.data;
        });
    },
    selectAll: function() {
      this.menuIdData = [];
      this.subdata = [];
      this.subdata = this.$refs.tree.getCheckedAndIndeterminateNodes(); //获取半选和全选的
      for (var i = 0; i < this.subdata.length; i++) {
        this.menuIdData.push(this.subdata[i].menuId);
      }
    },
    // 创建
    /**********************************************************************************/
    submit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          var roleList = {
            roleName: this.roleManagementForm.roleName,
            status: this.roleManagementForm.status,
            menuList: this.menuIdData,
            remark: this.roleManagementForm.remark
          };

          if (this.$route.query.id) {
            roleList.roleId = this.$route.query.id;
            // 编辑
            roleManagementVue.$api.security.updateRole(roleList).then(res => {
              setTimeout(() => {
                this.reload();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success(this.$t("common.editSuccess"));
                this.$router.push({
                  path: "/permissionsConfigurationManagement/roleManagement"
                });
              }, 1000);
            });
          } else {
            roleList.companyId = this.companyId;
            // 添加
            roleManagementVue.$api.security.createRole(roleList).then(res => {
              setTimeout(() => {
                this.reload();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success(this.$t("common.addSuccess"));
                this.$router.push({
                  path: "/permissionsConfigurationManagement/roleManagement"
                });
              }, 1000);
            });
          }
        } else {
          this.loading = false;
          if (this.$route.query.id > 0) {
            this.$Message.error(this.$t("common.editFail"));
          } else {
            this.$Message.error(this.$t("common.addFail"));
          }
        }
      });
    },
    // 返回
    backtrack: function() {
      this.$router.push({
        path: "/permissionsConfigurationManagement/roleManagement"
      });
    }
  }
};
</script>
<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
}

.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
.ivu-tree >>> .ivu-icon {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
.ivu-tree >>> .ivu-icon-ios-arrow-forward:before {
  content: "\F100";
  background-size: cover;
  width: 20px;
  height: 20px;
  display: block;
  font-size: 15px;
  margin-left: -3px;
  margin-top: 4px;
}
.ivu-tree >>> .ivu-tree-arrow-open .ivu-icon-ios-arrow-forward:before {
  content: "\F290";
  display: block;
  background-size: cover;
  width: 20px;
  height: 20px;
  font-size: 15px;
  margin-left: -3px;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/role_management/AddOrUpdateRoleManagement.vue